const CircleIcon = () => (
  <svg
    fill="none"
    height="35"
    viewBox="0 0 35 35"
    width="35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="17.5"
      cy="17.5"
      fill="#F3F3F0"
      r="16.75"
      stroke="#B1B1B1"
      strokeWidth="1.5"
    />
    <circle cx="17.5" cy="17.4998" fill="#B1B1B1" r="10.2083" />
  </svg>
)
export default CircleIcon
